import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import { Link } from '@ipc/ipc-core';
import {
  getData,
  getColumns,
  getIsLoading,
  getCheckedRows,
} from '../redux/selectors/BalanceOnHandThresholdsSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';
import { getUserRole } from '../../../../../common/user/redux/selectors/UserDataSelectors';
import { BalanceOnHandThresholdsContainerStyle } from './BalanceOnHandThresholdsContainer.styles';

class BalanceOnHandThresholdsContainer extends Component {
  componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      this.props.tableLoadData({ tableId: 'BALANCE_ON_HAND_THRESHOLDS_PAGE' }, this.props.appContext.appContext, { impcCode: this.props.clickedRow.impc });
    }
  }

  componentDidUpdate(prevProps) {
    const { clickedRow, appContext: { appContext } } = this.props;

    if (clickedRow !== prevProps.clickedRow) {
      this.props.tableLoadData({ tableId: 'BALANCE_ON_HAND_THRESHOLDS_PAGE' }, appContext, { impcCode: clickedRow.impc });
    }
  }

  render() {
    return (
      <div>
        {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER') || this.props.userRole.includes('IPC_TRAY_MANAGER') || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
          <Link to={{ pathname: 'balance-on-hand-thresholds-edit', state: { tableId: 'BALANCE_ON_HAND_THRESHOLDS_PAGE' } }}>
            <Button
              className={`primary-button-${!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}`}
              disabled={!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}
            >
              EDIT MIN/MAX
            </Button>
          </Link>
        )}
        <BalanceOnHandThresholdsContainerStyle>
          <ListTable
            listId={TableDefinitions.BALANCE_ON_HAND_THRESHOLDS_PAGE.id}
            loading={this.props.isLoading}
            columns={this.props.columns}
            data={this.props.data}
            keyField="id"
            selectCheckbox
          />
        </BalanceOnHandThresholdsContainerStyle>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    checkedRows: getCheckedRows(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
  };
}

BalanceOnHandThresholdsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  checkedRows: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  userRole: PropTypes.arrayOf(PropTypes.string),
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceOnHandThresholdsContainer);
